module.exports = __webpack_public_path__ + "static/media/bgImage1.13603c9d.jpeg";